import { createFileRoute, createLazyRoute } from '@tanstack/react-router';
import { useAuthnProvider } from '@ui/auth';
export const Route = createFileRoute('/logout')({
    component: ()=>null
});
function LogoutComponent() {
    const { logout } = useAuthnProvider();
    logout();
    return null;
}
export const LogoutLazyRoute = createLazyRoute('/logout')({
    component: LogoutComponent
});
